import { render, staticRenderFns } from "./ContactSideNav.vue?vue&type=template&id=1da00107&scoped=true&"
import script from "./ContactSideNav.vue?vue&type=script&lang=js&"
export * from "./ContactSideNav.vue?vue&type=script&lang=js&"
import style0 from "./ContactSideNav.vue?vue&type=style&index=0&id=1da00107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da00107",
  null
  
)

export default component.exports